import React from "react";
import { Card, LabeledData } from "@jsq/ds/core";
import EntityObjectsTable from "./EntityObjectsTable";
import FundFamilObjectsTable from "./FundFamilyObjectsTable";
import { hasSingleUserObject, hasObjectsWithAmounts } from "./utils";
import type { GetFundAdminServicesQuery } from "#graphql/supergraphTypes";

type ObjectDetailsCardProps = {
  requestType: string;
  objects: NonNullable<
    GetFundAdminServicesQuery["fundAdminServices"]
  >["edges"][number]["node"]["objects"];
};

const ObjectDetailsCard = ({ requestType, objects }: ObjectDetailsCardProps) => {
  const isSingleUserObject = hasSingleUserObject(objects);
  const isEntitiesWithAmounts = hasObjectsWithAmounts(objects);

  const getCardTitle = () => {
    if (isSingleUserObject) {
      return "User details";
    } else if (isEntitiesWithAmounts) {
      return "Entities and amounts";
    }

    return "Entities";
  };

  const firstObject = objects[0];
  const firstObjectType = firstObject.objectValue.__typename;
  const entityObjects = objects.filter(
    (object) => object.objectValue.__typename === "AccountObjectType",
  );
  const fundFamilyObjects = objects.filter(
    (object) => object.objectValue.__typename === "EntityCollectionObjectType",
  );

  return (
    <Card title={getCardTitle()}>
      {isSingleUserObject && firstObjectType === "UserObjectType" && (
        <>
          <LabeledData
            label="Staff user name"
            value={firstObject.objectValue.fullName}
            variant="row"
          />
          <LabeledData
            label="Email address"
            value={firstObject.objectValue.emailAddress}
            variant="row"
          />
        </>
      )}
      {fundFamilyObjects.length > 0 && (
        <FundFamilObjectsTable
          requestType={requestType}
          alsoHasEntityObjects={entityObjects.length > 0}
          fundFamilyObjects={fundFamilyObjects}
        />
      )}
      {entityObjects.length > 0 && (
        <EntityObjectsTable requestType={requestType} entityObjects={entityObjects} />
      )}
    </Card>
  );
};

export default ObjectDetailsCard;
